import React, {  Component } from 'react';
import { connect } from 'react-redux';
import ChangeZipCodeOverlayDialog from '../../dialogs/changeZipCodeOverlayDialog';

class ChangeZipCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChangeZipCodeOverlayDialog: false,
            filteredAvailQty: false
        };
        this.handleDialog = this.handleDialog.bind(this);
    }

    // event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    handleSelectZipCode(zipCode) {
        this.props.handleSelectZipCode(zipCode);
        this.handleDialog('ChangeZipCodeOverlayDialog', false, null);
    }

    render() {
        const self = this;
        const { accountNumber, zipCode, selectedAccount, saveCustomADC, customADC, disableLink } = self.props;
        const { userDetails } = self.props.state.user;
        const { typeOfUser } = userDetails;
        let showLink = false;
        const customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE.toLowerCase() : "";
        // enable the Hyperlink only when the Channel for the account is NOT Retail OR when the Channel is Retail and the Classification is Premium Incentive.
        if (!disableLink && (self.props.typeOfAccount !== 'RETAIL' || customerClassCode === 'premium incentive') && typeOfUser === 'customer') {
            showLink = true;
        }
        //commenting as part of WCP-7305
        //const canadianZip = selectedAddress && isCanadianZipCode(JSON.parse(selectedAddress).POSTALCODE);
        return (
            <span>
                <strong>Results shown are for: </strong> &nbsp;
                {accountNumber && <span>Account # {accountNumber} &nbsp; </span>}Zip Code &nbsp;
                { showLink 
                //&& !canadianZip
                    ? <a href="" onClick={(e) => this.handleDialog('ChangeZipCodeOverlayDialog', true, e)}>
                        {zipCode}
                    </a>
                    : zipCode
                } &nbsp; {typeOfUser === 'employee' && <span>ADC: <strong>{customADC}</strong></span>} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
               {self.props.showInStockFilter?
                 <label className='inStockStyle'>{"Show only IN STOCK products"}<input type='checkbox' checked={self.props.filteredAvailQty} onChange={this.props.handleSelectAvail}/></label>:""}
                   &nbsp;  &nbsp;  &nbsp;
                {self.props.showExcludeNlaFilter?
                <label className='inStockStyle'>{"Exclude NLA products"}<input type='checkbox' checked={self.props.filterNLA} onChange={this.props.handleExcludeNla}/></label>:""}
                <br /><br />
                {this.state.showChangeZipCodeOverlayDialog?<ChangeZipCodeOverlayDialog saveCustomADC={saveCustomADC} getShippingAddressesDetails={this.props.getShippingAddressesDetails} acceptNumbersOnly={this.props.acceptNumbersOnly} handleSelectZipCode={this.handleSelectZipCode.bind(this)} zipCode={zipCode} handleDialog={this.handleDialog} showDialog={true} />:null}
            </span>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
});

ChangeZipCode = connect(mapStateToProps, mapDispatchToProps)(ChangeZipCode);
export default ChangeZipCode;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/changeZipCode.js